// extracted by mini-css-extract-plugin
module.exports = {"PersonalDataContainer":"PersonalData_PersonalDataContainer__2fxV7"};